export const disableBodyScrolling = (includeX = false) => {
  document.body.style.inset = `-${window.scrollY}px -${
    includeX ? window.scrollX : 0
  } 0`;
  document.body.style.position = 'fixed';
  document.body.style.overflowY = 'scroll';
  document.body.style.overscrollBehavior = 'none';
  document.querySelector('html')!.style.overscrollBehavior = 'none';
};

export const enableBodyScrolling = () => {
  if (!!document.body.style.inset) {
    const insetSplit = document.body.style.inset.split(' ');
    const scrollY = parseFloat(
      insetSplit[0]?.replace('px', '').replace('-', '') ?? '0'
    );
    const scrollX = parseFloat(
      insetSplit[1]?.replace('px', '').replace('-', '') ?? '0'
    );
    document.body.style.inset = '';
    document.body.style.position = '';
    document.body.style.overflowY = '';
    document.body.style.overscrollBehavior = '';
    document.querySelector('html')!.style.overscrollBehavior = '';
    window.scrollTo({ top: scrollY, left: scrollX, behavior: 'auto' });
  }
};
